var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-pdf-3747255",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.346,
    height: 25.9,
    viewBox: "0 0 19.346 25.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11320",
    "data-name": "Path 11320",
    d: "M466,769.742s.667-.269,1.763-1.992A6.976,6.976,0,0,0,466,769.742Z",
    transform: "translate(-461.656 -748.116)",
    fill: "#0f55cb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11321",
    "data-name": "Path 11321",
    d: "M686.386,280.579l-4.981-4.981a1.216,1.216,0,0,0-.857-.349h-.3V281.7H686.7V281.4A1.206,1.206,0,0,0,686.386,280.579Z",
    transform: "translate(-667.369 -275.24)",
    fill: "#0f55cb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11322",
    "data-name": "Path 11322",
    d: "M369.488,283.109a1.215,1.215,0,0,1-1.215-1.215V275H358.181a1.205,1.205,0,0,0-1.205,1.215v23.429a1.205,1.205,0,0,0,1.205,1.255h16.934a1.205,1.205,0,0,0,1.205-1.215V283.109Zm2.311,11.217a7.6,7.6,0,0,1-3.227-1,29.363,29.363,0,0,0-3.985,1.175c-1.285,2.2-2.182,3.108-3.078,3.108a1.544,1.544,0,0,1-1.086-.5c-1-1.185,1.375-2.729,2.749-3.427a46.59,46.59,0,0,0,2.052-4.323,8.437,8.437,0,0,1-.408-3.885,1.265,1.265,0,0,1,2.411.339,7.112,7.112,0,0,1-.309,3.237,5.05,5.05,0,0,0,2.152,2.719c1-.129,2.988-.329,3.716.359a1.3,1.3,0,0,1-.986,2.192Z",
    transform: "translate(-356.975 -275)",
    fill: "#0f55cb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11323",
    "data-name": "Path 11323",
    d: "M582.322,540.75a4.882,4.882,0,0,0,.1,2.371C582.7,542.613,582.74,540.75,582.322,540.75Z",
    transform: "translate(-573.246 -530.161)",
    fill: "#0f55cb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11324",
    "data-name": "Path 11324",
    d: "M551.395,659.75A21.893,21.893,0,0,1,550,662.918a18.432,18.432,0,0,1,3.178-1.106A6.592,6.592,0,0,1,551.395,659.75Z",
    transform: "translate(-542.309 -644.419)",
    fill: "#0f55cb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11325",
    "data-name": "Path 11325",
    d: "M686.25,719.871c1.873.8,2.152.458,2.152.458C688.611,720.19,688.282,719.731,686.25,719.871Z",
    transform: "translate(-673.13 -702.12)",
    fill: "#0f55cb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.93a61654194c33e3251a43954176ae30.svg";
export { ForwardRef as ReactComponent };